export default "__VITE_ASSET__BeeqnsHx__"